import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Accommodation from "./pages/Accommodation";
import Faq from "./pages/Faq";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import './App.css';

const animationStyles = ["fade-up", "fade-up", "fade-left", "fade-right"];

function AnimatedRoutes() {
  const location = useLocation();

  useEffect(() => {
    // Every route starts at the top rather than retaining the prior page position.
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    const elements = document.querySelectorAll(
      "main > section, main > .home__minicards, main > .home__stats, .promise, .footer",
    );

    elements.forEach((element, index) => {
      element.setAttribute(
        "data-aos",
        animationStyles[index % animationStyles.length],
      );
      element.setAttribute("data-aos-duration", "850");
      element.setAttribute("data-aos-easing", "ease-out-cubic");
      element.setAttribute("data-aos-once", "true");
      element.setAttribute("data-aos-anchor-placement", "top-bottom");
    });

    AOS.init({
      duration: 850,
      easing: "ease-out-cubic",
      once: true,
      offset: 90,
      disable: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    });

    AOS.refreshHard();
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/" exact="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/accommodation" element={<Accommodation />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/testimonials" element={<Testimonials />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AnimatedRoutes />
    </BrowserRouter>
  );
}
